import React from 'react';
import '../Users/Shimmer/Shimmer.scss';

const bar = width => <div className='shimmer' style={{ height: 12, width, borderRadius: 6 }} />;
const dot = () => <div className='shimmer' style={{ height: 16, width: 16, borderRadius: '50%', flexShrink: 0 }} />;

const WaitlistShimmerRow = () => (
  <div className='waitlist-user row shimmer-row'>
    <div className='cell created'>{bar('70%')}</div>
    <div className='cell name'>{bar('55%')}</div>
    <div className='cell email'>{bar('80%')}</div>
    <div className='cell links icon-container'>{dot()}{dot()}{dot()}{dot()}{dot()}{dot()}</div>
    <div className='cell followers'>{bar('60%')}</div>
    <div className='cell referred'>{bar('50%')}</div>
    <div className='cell location'>{bar('65%')}</div>
    <div className='cell status'>{bar('70%')}</div>
  </div>
);

export default WaitlistShimmerRow;
